const CloseIcon = () => {
  return (
    <>
      <svg
        version="1.1"
        id="Ebene_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        enableBackground="new 0 0 24 24"
        xmlSpace="preserve"
      >
        <path
          fill="#FDA816"
          d="M12,0C5.383,0,0,5.383,0,12c0,6.617,5.383,12,12,12c6.617,0,12-5.383,12-12C24,5.383,18.617,0,12,0z M12,22
	C6.486,22,2,17.514,2,12C2,6.486,6.486,2,12,2c5.514,0,10,4.486,10,10C22,17.514,17.514,22,12,22z"
        />
        <path
          fill="#FDA816"
          d="M16.242,7.757c-0.391-0.391-1.023-0.391-1.414,0L12,10.586L9.171,7.757c-0.391-0.391-1.023-0.391-1.414,0
	s-0.391,1.023,0,1.414L10.586,12l-2.828,2.828c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293
	s0.512-0.098,0.707-0.293L12,13.414l2.828,2.828c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293
	c0.391-0.391,0.391-1.023,0-1.414L13.414,12l2.828-2.828C16.633,8.781,16.633,8.148,16.242,7.757z"
        />
      </svg>
    </>
  );
};

export default CloseIcon;
